import type {
	ShopDto,
	UpdateOneBrevoIntegrationDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateBrevoIntegration(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/integrations/brevo",
		{
			invalidate: invalidateShop,
			mapVariables: (requestBody: UpdateOneBrevoIntegrationDto) => ({
				params: { path: { shopId: shop.id } },
				body: requestBody,
			}),
		},
	);
}
